import { render, staticRenderFns } from "./AppDownloadQR.vue?vue&type=template&id=a49ab4fa&scoped=true"
import script from "./AppDownloadQR.vue?vue&type=script&lang=js"
export * from "./AppDownloadQR.vue?vue&type=script&lang=js"
import style0 from "./AppDownloadQR.vue?vue&type=style&index=0&id=a49ab4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49ab4fa",
  null
  
)

export default component.exports